function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { TextField } from 'seagull';
import { positiveQuantityInputProps } from "../../../constants";
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
export default function MinPriceTextField() {
  const {
    control,
    watch,
    trigger
  } = useFormContext();
  const [pricing, price] = watch(['pricing', 'price']);
  useEffect(() => {
    trigger('minPrice');
  }, [pricing, price]);
  return /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "minPrice",
    rules: {
      validate: minPrice => {
        if (minPrice && price && +minPrice >= +price) {
          return "Min can't exceed or equal max";
        }
      }
    },
    render: renderProps => /*#__PURE__*/React.createElement(TextField, _extends({
      isMoney: true,
      alwaysShrinkLabel: true,
      inputProps: positiveQuantityInputProps,
      label: "Min price (optional)",
      prefix: "$",
      "data-testid": "sb-min-price"
    }, connectControllerToTextField(renderProps)))
  });
}